import React from 'react'

import { Button } from '@insquad/tools'
import Image from 'next/image'

import { BannerAnimation } from 'src/common/animations/BannerAnimation/BannerAnimation'
import { Logo } from 'src/common/components/Logo/Logo'
import {
  Typography,
  EnumTypographyVariants,
} from 'src/common/components/Typography/Typography'
import { useAuthRedirect } from 'src/common/hooks/useAuthRedirect'
import { AnalyticEventEnum } from 'src/utils/analytic/analyticEventEnum'
import { useAnalytic } from 'src/utils/analytic/useAnalytic'

import developersCollageSmallImg from './developersCollageSmall.png'

import s from './ResumeHireBanner.module.scss'

export interface IResumeHireBannerProps {
  resumeId: string
}

export const ResumeHireBanner: React.FC<IResumeHireBannerProps> = ({
  resumeId,
}) => {
  const { analytic } = useAnalytic()
  const { handleSignUpRedirect } = useAuthRedirect()

  const handleSignUp = () => {
    analytic.event(AnalyticEventEnum.SIGN_UP, {
      page: 'profile',
      from: 'header',
    })

    const additionalQuery = `resume-id=${resumeId}`
    handleSignUpRedirect(additionalQuery)
  }

  return (
    <BannerAnimation
      isVisible
      rootProps={{
        className: s.ResumeHireBanner,
      }}
      delay={380}
    >
      <div className={s.ResumeHireBanner__info}>
        <Logo className={s.ResumeHireBanner__logo} isSmall />

        <Typography
          variant={EnumTypographyVariants.H2F}
          text="Do you need to hire vetted senior developers?"
          className={s.ResumeHireBanner__title}
        />

        <Typography
          variant={EnumTypographyVariants.P1F}
          text="Sign up with Insquad to hire qualified developers from all over the world"
          className={s.ResumeHireBanner__description}
        />

        <Button onClick={handleSignUp} className={s.ResumeHireBanner__btn}>
          Sign up
        </Button>
      </div>

      <div className={s.ResumeHireBanner__imgWrapper}>
        <Image
          src={developersCollageSmallImg}
          className={s.ResumeHireBanner__img}
          layout="fixed"
          width={354}
          height={208}
          alt=""
          unoptimized
        />
      </div>
    </BannerAnimation>
  )
}
